import type { ConfigOverrideKey } from '#dn-types/host.ts';
import type {
  LoggingTimestampLabel,
  LoggingTimestampValue,
  STATS_TYPE,
} from '#schemas/config-override/helpers/enums.ts';

type StatsType = (typeof STATS_TYPE)[number]; // Used in Tags host config settings dropdown
export type ConfigKey = ConfigOverrideKey | StatsType;

export const CONFIG_OVERRIDE_LABELS: Record<ConfigKey, string> = {
  'definednet.dns.resolver_addrs': 'DNS resolvers',
  'definednet.dns.match_domains': 'Match domains',
  'definednet.dns.search_domains': 'Search domains',
  'lighthouse.remote_allow_list': 'Remote allow list',
  'lighthouse.local_allow_list': 'Local allow list',
  'lighthouse.serve_dns': 'Serve DNS',
  'lighthouse.advertise_addrs': 'Advertise addresses',
  'lighthouse.dns.host': 'DNS host',
  'lighthouse.dns.port': 'DNS port',
  'lighthouse.interval': 'Lighthouse interval',
  preferred_ranges: 'Preferred ranges',
  'listen.host': 'Listen host',
  'tun.disabled': 'Disable interface',
  'tun.dev': 'Interface Name',
  'tun.mtu': 'MTU',
  'tun.tx_queue': 'TX queue',
  'listen.batch': 'Batch',
  'listen.read_buffer': 'Read buffer',
  'listen.write_buffer': 'Write buffer',
  routines: 'Routines',
  'listen.udp_offloads': 'UDP offloads',
  'tun.use_offloads': 'TUN offloads',
  'logging.level': 'Level',
  'logging.format': 'Output format',
  'logging.timestamp_format': 'Timestamp format',
  prometheus: 'Prometheus',
  graphite: 'Graphite',
  'stats.type': 'Type',
  'stats.listen': 'Listen',
  'stats.path': 'Path',
  'stats.namespace': 'Namespace',
  'stats.subsystem': 'Subsystem',
  'stats.host': 'Host',
  'stats.prefix': 'Prefix',
  'stats.interval': 'Interval',
  'stats.lighthouse_metrics': 'Lighthouse metrics',
  'stats.message_metrics': 'Message metrics',
  'static_map.network': 'Static map network',
  'punchy.delay': 'Punch delay',
  'punchy.respond_delay': 'Punch respond delay',
};

export const STATS_TYPE_LABELS = {
  prometheus: 'Prometheus',
  graphite: 'Graphite',
};

export const LOGGING_FORMAT_LABELS = {
  text: 'Text',
  json: 'JSON',
};

export const STATIC_MAP_NETWORK_LABELS = {
  ip: 'IP',
  ip4: 'IPv4',
  ip6: 'IPv6',
};

export const LOGGING_TIMESTAMP_FORMAT_LABELS: Record<LoggingTimestampValue, LoggingTimestampLabel> = {
  "01/02 03:04:05PM '06 -0700": 'Layout',
  'Mon Jan _2 15:04:05 2006': 'ANSIC',
  'Mon Jan _2 15:04:05 MST 2006': 'Unix Date',
  'Mon Jan 02 15:04:05 -0700 2006': 'Ruby Date',
  '02 Jan 06 15:04 MST': 'RFC822',
  '02 Jan 06 15:04 -0700': 'RFC822Z',
  'Monday, 02-Jan-06 15:04:05 MST': 'RFC850',
  'Mon, 02 Jan 2006 15:04:05 MST': 'RFC1123',
  'Mon, 02 Jan 2006 15:04:05 -0700': 'RFC1123Z',
  '2006-01-02T15:04:05Z07:00': 'RFC3339',
  '2006-01-02T15:04:05.999999999Z07:00': 'RFC3339 Nano',
  '3:04PM': 'Kitchen',
  'Jan _2 15:04:05': 'Stamp',
  'Jan _2 15:04:05.000': 'Stamp Milli',
  'Jan _2 15:04:05.000000': 'Stamp Micro',
  'Jan _2 15:04:05.000000000': 'Stamp Nano',
};
